var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.035 10.233c-.316-3.276-3.143-4.374-6.717-4.687V1h-2.766v4.425c-.726 0-1.47.014-2.207.03V1H10.58l-.002 4.542c-.6.012-1.188.024-1.762.024v-.014L5.002 5.55v2.955s2.043-.039 2.008-.002c1.121 0 1.485.65 1.59 1.212v5.178c.08 0 .18.004.293.02H8.6v7.255c-.05.352-.257.914-1.04.916.035.03-2.01 0-2.01 0L5 26.387h3.6c.67 0 1.33.012 1.976.016L10.578 31h2.763v-4.548c.758.015 1.492.021 2.21.021L15.55 31h2.764v-4.587c4.65-.267 7.909-1.439 8.312-5.807.326-3.517-1.327-5.088-3.967-5.723 1.605-.814 2.61-2.252 2.375-4.65zm-3.872 9.829c0 3.435-5.88 3.045-7.757 3.045v-6.092c1.876.004 7.757-.535 7.757 3.047zm-1.287-8.594c0 3.126-4.909 2.76-6.47 2.762V8.707c1.563 0 6.472-.497 6.47 2.761z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsv);
export default __webpack_public_path__ + "static/media/BSV.f01a3097a8a1e678eeecbe9f618a853d.svg";
export { ForwardRef as ReactComponent };